import React from 'react'
import { t } from 'ttag'

import { Button } from 'components/shared/Button/Button'
import { Modal } from 'components/shared/Modal/Modal'

import styles from './PositionSelectionModal.module.scss'

export const PositionSelectionModal = ({
  onClose,
  onCreateTemplate,
  onFromScratch,
  isOpen,
}) => (
  <Modal
    className={styles.modal}
    title={t`Create job`}
    {...{ onClose, isOpen }}
  >
    <Modal.Header />
    <Modal.Content className={styles.content}>
      <div className={styles.container}>
        <Button
          className={styles.button}
          label={t`Use template`}
          size="medium"
          variant="outlined"
          onClick={onCreateTemplate}
        />
        <span className={styles.text}>{t`or`}</span>
        <Button
          className={styles.button}
          color="primary"
          label={t`Start from scratch`}
          size="medium"
          variant="filled"
          onClick={onFromScratch}
        />
      </div>
    </Modal.Content>
  </Modal>
)
